export default "__VITE_ASSET__hk6Yh0Pj__"